import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { format_date, toFixed, DateInput } from "../CustomComponent";
import { STATUS_META, toThaiYear } from "./constants";

const toInput = (value) => (value === null || value === undefined ? "" : String(value));

// กรอกตัวเลขที่ยื่นจริงทับค่าที่ระบบคำนวณให้ ของแบบภาษี 1 ใบต่อ 1 งวด
export default function FilingModal({ show, cell, year, onHide, onSave, onReset }) {
  const [form, setForm] = useState(null);

  useEffect(() => {
    if (!cell) {
      setForm(null);
      return;
    }
    setForm({
      base_amount: toInput(cell.base),
      tax_amount: toInput(cell.tax),
      surcharge: toInput(cell.surcharge || (cell.overdue ? cell.suggested_surcharge : 0)),
      penalty: toInput(cell.penalty),
      status: cell.status || "pending",
      filed_date: cell.filed_date ? String(cell.filed_date).slice(0, 10) : "",
      reference_no: cell.reference_no || "",
      note: cell.note || "",
    });
  }, [cell]);

  if (!cell || !form) return null;

  const setField = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));
  const useAuto = () => setForm((prev) => ({ ...prev, base_amount: toInput(cell.auto.base), tax_amount: toInput(cell.auto.tax) }));

  const total = (Number(form.tax_amount) || 0) + (Number(form.surcharge) || 0) + (Number(form.penalty) || 0);

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton className="border-0">
        <Modal.Title as="h5" className="fw-semibold">
          {cell.label} · {cell.period_month ? `งวด ${cell.period_month}` : `ปีภาษี ${toThaiYear(year)}`}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="rounded-3 p-3 mb-3" style={{ background: "#f6f9fc", border: "1px solid #e2e8ec" }}>
          <div className="fw-semibold mb-1" style={{ color: "#0b4f84" }}>{cell.full_label}</div>
          <div className="small text-secondary">{cell.hint}</div>
          <div className="small mt-2" style={{ color: "#12314d" }}>
            กำหนดยื่น {cell.due_date ? format_date(cell.due_date, "dd/mm/yyyy") : "-"} · ยื่นออนไลน์ได้ถึง{" "}
            {cell.efiling_due_date ? format_date(cell.efiling_due_date, "dd/mm/yyyy") : "-"}
          </div>
        </div>

        <div className="rounded-3 p-3 mb-3" style={{ background: "rgba(12, 118, 229, 0.05)", border: "1px solid rgba(12, 118, 229, 0.16)" }}>
          <div className="d-flex justify-content-between align-items-center gap-2 flex-wrap">
            <div className="small" style={{ color: "#12314d" }}>
              ระบบคำนวณจากข้อมูลในระบบได้: ฐานภาษี <b>{toFixed(cell.auto.base)}</b> · ภาษี <b>{toFixed(cell.auto.tax)}</b>
              {cell.form_type === "pp30" ? (
                <div className="text-secondary">
                  ภาษีขาย {toFixed(cell.auto.output_vat)} − ภาษีซื้อ {toFixed(cell.auto.input_vat)}
                  {cell.auto.credit > 0 ? ` · เครดิตยกไปเดือนถัดไป ${toFixed(cell.auto.credit)}` : ""}
                </div>
              ) : null}
              {cell.form_type === "sso" ? (
                <div className="text-secondary">
                  ลูกจ้าง {toFixed(cell.auto.employee)} + นายจ้าง {toFixed(cell.auto.employer)}
                </div>
              ) : null}
            </div>
            <button type="button" className="btn btn-sm btn-outline-primary rounded-3" onClick={useAuto}>
              ใช้ตัวเลขนี้
            </button>
          </div>
        </div>

        <div className="row g-3">
          <div className="col-12 col-md-6">
            <label className="form-label">ฐานภาษี / ยอดเงินได้ที่จ่าย</label>
            <input type="number" step="0.01" className="form-control" value={form.base_amount} onChange={(event) => setField("base_amount", event.target.value)} />
          </div>
          <div className="col-12 col-md-6">
            <label className="form-label">ภาษีที่ต้องนำส่ง</label>
            <input type="number" step="0.01" className="form-control" value={form.tax_amount} onChange={(event) => setField("tax_amount", event.target.value)} />
          </div>

          <div className="col-12 col-md-6">
            <label className="form-label">เงินเพิ่ม (ยื่นล่าช้า 1.5%/เดือน)</label>
            <input type="number" step="0.01" className="form-control" value={form.surcharge} onChange={(event) => setField("surcharge", event.target.value)} />
            {cell.overdue && cell.suggested_surcharge > 0 ? (
              <div className="small mt-1" style={{ color: "#b63636" }}>
                เลยกำหนดแล้ว ระบบประมาณเงินเพิ่มไว้ที่ {toFixed(cell.suggested_surcharge)} บาท
              </div>
            ) : null}
          </div>
          <div className="col-12 col-md-6">
            <label className="form-label">ค่าปรับ</label>
            <input type="number" step="0.01" className="form-control" value={form.penalty} onChange={(event) => setField("penalty", event.target.value)} />
          </div>

          <div className="col-12 col-md-4">
            <label className="form-label">สถานะ</label>
            <select className="form-select" value={form.status} onChange={(event) => setField("status", event.target.value)}>
              {Object.entries(STATUS_META).map(([value, meta]) => (
                <option key={value} value={value}>{meta.label}</option>
              ))}
            </select>
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label">วันที่ยื่นจริง</label>
            <DateInput className="form-control" value={form.filed_date} onChange={(event) => setField("filed_date", event.target.value)} />
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label">เลขที่อ้างอิง / ใบเสร็จ</label>
            <input type="text" className="form-control" value={form.reference_no} onChange={(event) => setField("reference_no", event.target.value)} />
          </div>

          <div className="col-12">
            <label className="form-label">หมายเหตุ</label>
            <input type="text" className="form-control" value={form.note} onChange={(event) => setField("note", event.target.value)} />
          </div>
        </div>

        <div className="rounded-3 p-3 mt-3 d-flex justify-content-between align-items-center" style={{ background: "#f6f9fc" }}>
          <span className="fw-semibold">รวมที่ต้องจ่ายงวดนี้</span>
          <span className="fw-bold" style={{ color: "#b63636" }}>{toFixed(total)} บาท</span>
        </div>
      </Modal.Body>

      <Modal.Footer className="border-0 d-flex justify-content-between">
        <div>
          {cell.uid ? (
            <button className="btn btn-outline-danger rounded-3" onClick={() => onReset(cell)}>
              ล้างค่าที่กรอก กลับไปใช้ตัวเลขระบบ
            </button>
          ) : null}
        </div>
        <div className="d-flex gap-2">
          <button className="btn btn-secondary rounded-3" onClick={onHide}>ยกเลิก</button>
          <button className="btn btn-primary rounded-3 px-4" onClick={() => onSave(cell, form)}>บันทึก</button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
